import { useCallback } from "react";
import useDeligenceStatus from "./useDeligenceStatus";
import { diligenceObservable } from "../observers/deligenceObservable";
import { utilityService } from "../requests/utilityService";
import { sharedData } from "../sharedData/sharedData";

// Country change handler for UBO forms that had no country risk check at all
// (Foundations, Fund, Public Sector). A high-risk country makes the request Enhanced
// straight away, with no popup. Picking another country first clears this UBO's entry,
// and ownerId starts with renderBy + index so removing the UBO or changing its type
// clears it too (removeByPrefix).
export const useUboCountryRisk = (ownerId, onChange) => {
    const { getDeligenceStatusByCountry } = useDeligenceStatus();

    return useCallback(async (event) => {
        const { name, value } = event.target;
        onChange({ target: { name, value } });
        diligenceObservable.remove(ownerId);
        if (!value || value === "None") return;
        const response = await getDeligenceStatusByCountry(value);
        if (response && response.some((item) => item.Diligence?.toLowerCase() === "enhanced")) {
            diligenceObservable.setValue("Enhanced", ownerId);
            // Same write the "Proceed with Enhanced" button makes in CountryRiskPopup.
            utilityService.updateDiligenceStatus(sharedData.get("entityId"), "Enhanced");
        }
    }, [getDeligenceStatusByCountry, onChange, ownerId]);
};
